import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationPL from "./locales/pl.json";
import translationEN from "./locales/en.json";
import translationDE from "./locales/de.json";

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "pl");
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: translationPL },
      en: { translation: translationEN },
      de: { translation: translationDE },
    },
    lng: localStorage.getItem("I18N_LANGUAGE") || "pl",
    fallbackLng: "pl",
    keySeparator: ".",
    interpolation: { escapeValue: false },
  });

export default i18n;
